// extracted by mini-css-extract-plugin
module.exports = {"modal":"SummarySettingsModal_modal__1fEOh","title":"SummarySettingsModal_title__j1PLh"};